import { render, staticRenderFns } from "./AssignmentMenu.vue?vue&type=template&id=514c4fe7&scoped=true&"
import script from "./AssignmentMenu.vue?vue&type=script&lang=ts&"
export * from "./AssignmentMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentMenu.vue?vue&type=style&index=0&id=514c4fe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c4fe7",
  null
  
)

export default component.exports